import React from 'react';
import AdBanner from '../components/AdBanner';
import SEO from '../components/SEO';

const About = () => {
  return (
    <div className="min-h-screen bg-stone-50 py-10 md:py-16">
      <SEO
        title="हमारे बारे में (About Us)"
        description="नाथ नगरी बरेली के सात प्राचीन शिव मंदिरों के बारे में जानें। Discover the history of Nathnagri Temples."
        keywords="about us, nathnagri history, bareilly shiva temples"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <h1 className="text-4xl font-extrabold text-stone-900 mb-4">हमारे बारे में (About Us)</h1>
          <p className="text-lg text-stone-600">नाथ नगरी की प्राचीन और आध्यात्मिक विरासत का अन्वेषण करें।</p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* Main Content (Left) */}
          <div className="flex-1 bg-white p-8 rounded-2xl border border-stone-100 shadow-sm prose prose-lg prose-stone max-w-none [&>p]:mb-6 [&>h3]:text-2xl [&>h3]:font-bold [&>h3]:mb-4 [&>h3]:mt-8">
            <p>
              बरेली शहर को "नाथ नगरी" के रूप में जाना जाता है क्योंकि इसके चारों कोनों और मध्य में भगवान शिव के सात प्राचीन मंदिर स्थित हैं।
              ये मंदिर बरेली की आध्यात्मिक और सांस्कृतिक विरासत के प्रतीक हैं। हर साल लाखों भक्त यहाँ दर्शन के लिए आते हैं, विशेषकर सावन के महीने में।
            </p>
            <h3>नाथ मंदिरों का महत्व</h3>
            <p>
              इन सात मंदिरों—अलखनाथ, त्रिवटी नाथ, मढ़ीनाथ, धोपेश्वरनाथ, बनखंडीनाथ, तपेश्वरनाथ, और पशुपतिनाथ—के कारण ही इस क्षेत्र में एक विशेष प्रकार की ऊर्जा और शांति का अनुभव होता है।
              प्रत्येक मंदिर का अपना ऐतिहासिक और पौराणिक महत्व है। कोई मंदिर घने जंगल (बनखंडीनाथ) के मध्य स्थित था, तो किसी की उत्पत्ति भगवान शिव के प्रत्यक्ष दर्शन (त्रिवटी नाथ) से हुई।
            </p>

            <h3><strong>बरेली का इतिहास (Bareilly ka Itihas)</strong></h3>

            <p>
              बरेली, उत्तर प्रदेश के प्रमुख और ऐतिहासिक शहरों में से एक है, जो पश्चिमी उत्तर प्रदेश के महत्वपूर्ण केंद्र के रूप में जाना जाता है। यह शहर रोहिलखंड क्षेत्र का मुख्य भाग है और प्रशासनिक दृष्टि से भी इसका विशेष महत्व है। रामगंगा नदी के किनारे बसा बरेली, भौगोलिक रूप से उपजाऊ गंगा-यमुना मैदान में स्थित है, जिसने इसके विकास में अहम भूमिका निभाई है।
            </p>

            <p>
              इतिहास के अनुसार, बरेली की स्थापना 16वीं शताब्दी में एक स्थानीय शासक जगत सिंह कटेहरिया द्वारा की गई थी। उन्होंने इस स्थान का नाम अपने पुत्रों के नाम पर “बांस-बरेली” रखा, जो समय के साथ बदलकर “बरेली” हो गया। मुगल शासन के दौरान यह क्षेत्र तेजी से विकसित हुआ और प्रशासनिक केंद्र के रूप में उभरा।
            </p>

            <p>
              17वीं शताब्दी में मुगल शासन के अंतर्गत बरेली को एक महत्वपूर्ण नगर के रूप में स्थापित किया गया। बाद में मुगल साम्राज्य के कमजोर होने के साथ रोहिलखंड क्षेत्र का उदय हुआ, जिसमें बरेली एक प्रमुख केंद्र बन गया। इसके बाद यह क्षेत्र अवध के नवाबों के अधीन आया और फिर ब्रिटिश शासन के अंतर्गत शामिल कर लिया गया।
            </p>

            <p>
              ब्रिटिश काल में बरेली का और अधिक विकास हुआ, खासकर सैन्य और प्रशासनिक दृष्टि से। यहाँ छावनी और किले का निर्माण किया गया, जिससे यह रणनीतिक रूप से महत्वपूर्ण शहर बन गया। 1857 के प्रथम स्वतंत्रता संग्राम में बरेली ने महत्वपूर्ण भूमिका निभाई। इस दौरान खान बहादुर खान के नेतृत्व में बरेली कुछ समय के लिए स्वतंत्र भी रहा, जो इसके गौरवशाली इतिहास का अहम हिस्सा है।
            </p>

            <p>
              आज बरेली एक विकसित शहर के रूप में जाना जाता है, जहाँ परंपरा और आधुनिकता का अद्भुत संगम देखने को मिलता है। यह शहर धार्मिक स्थलों, विशेष रूप से नाथ मंदिरों के लिए प्रसिद्ध है, जिसके कारण इसे “नाथ नगरी” भी कहा जाता है। यहाँ आने वाले श्रद्धालु और पर्यटक इस शहर की ऐतिहासिक विरासत और सांस्कृतिक समृद्धि का अनुभव करते हैं।
            </p>

            <p>
              इस प्रकार, बरेली का इतिहास केवल एक शहर की कहानी नहीं है, बल्कि यह सांस्कृतिक धरोहर, संघर्ष और निरंतर विकास की एक प्रेरणादायक यात्रा है, जो इसे उत्तर प्रदेश के प्रमुख शहरों में एक विशेष स्थान प्रदान करती है।
            </p>

            <h3>हमारा उद्देश्य</h3>
            <p>
              नाथ नगरी बरेली वेबसाइट का उद्देश्य इन पवित्र सिद्धपीठों के बारे में विस्तृत जानकारी प्रदान करना है ताकि यहाँ आने वाले श्रद्धालु और अन्य लोग इसके इतिहास,
              आरती व दर्शन के समय, और धार्मिक आयोजनों से अवगत रह सकें। हम एक डिजिटल माध्यम से सनातन धर्म की इस अमूल्य धरोहर को सहेजने और दुनिया भर में फैलाने का प्रयास कर रहे हैं।
            </p>
          </div>

          {/* Sidebar (Right) */}
          <div className="w-full lg:w-80 flex-shrink-0">
            <AdBanner placement="sidebar" pageName="about" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
